<template>
  <div class="content-wrapper">

    <section class="contact-header-section">
      <div class="contact-header">
        <div class="header-content">
          <div class="header-title">{{ t('footerContact') }}</div>
          <el-row class="contact-links-row">
            <el-col :span="8" class="link-col">
              <router-link to="/ContactUs" class="a-style">{{ t('contactOnline') }}</router-link>
            </el-col>
            <el-col :span="8" class="link-col middle">
              <router-link to="/xiaoshou" class="a-style">{{ t('contactSales') }}</router-link>
            </el-col>
            <el-col :span="8" class="link-col" style="color:#FFFFFF;background-color: #312D64;">
              <router-link to="/shouhou" class="a-style">{{ t('contactService') }}</router-link>
            </el-col>
          </el-row>
        </div>
      </div>

    </section>


    <div class="warranty-section">
      <div class="left-box">
        <div class="title">{{ t('title') }}</div>
        <div class="description" style="margin-top:20px;">{{ t('title1') }}</div>
        <ul class="description" style="margin-top:20px;">
          <li>{{ t('step1') }}</li>
          <li>{{ t('step2') }}</li>
          <li>{{ t('step3') }}</li>
          <li>{{ t('step4') }}</li>
        </ul>
        <div class="contact">
          <p>{{ t('email1') }}：support@guohuitech.com</p>
          <p style="margin-top:-10px;">{{ t('workingHours') }}：{{ t('time') }}</p>
        </div>
      </div>
      <div class="right-box">
        <el-input v-model="form.email" :placeholder="t('emailInput')" class="input"></el-input>
        <div class="code-box">
          <el-input v-model="form.code" :placeholder="t('codeInput')" class="input-code" />
          <el-button
              @click="sendCode"
              :disabled="isCountingDown"
              :loading="sendingCode"
              class="send-code-btn">
            {{ countdown > 0 ? `${countdown}s` : t('sendCode') }}
          </el-button>
        </div>
        <div class="agree">
          <el-checkbox style="color:#FFFFFF;" v-model="form.agree">{{ t('agree') }}</el-checkbox>
        </div>
        <el-input v-model="form.rma" :placeholder="t('rmaInput')" class="input"></el-input>
        <el-button
            @click="verifyCode"

            class="send-code-btn1">
          {{ t('searchRwa') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getNextInfo, listContactInfo, sendEmailCode, verify} from "@/utils/http";
export default {
  props: ['t', 'currentLang'],
  data() {
    return {
      form: {
        email: '',
        code: '',
        rma: '',
        agree: false
      },
      countdown: 0,
      isCountingDown: false,
      sendingCode: false,

      countdownInterval: null,
      resultMsg:''
    }
  },
  methods: {
    sendEmailCode1(){
      sendEmailCode(this.params).then(response => {
        this.resultMsg=response.data;
      })
    },
    verifyCode(){
      const param={
        email:this.form.email,
        code:this.form.code,
        rwaCode:this.form.rma
      }
      verify(param).then(response => {
        this.$alert(response, '查询信息', {
          confirmButtonText: '确定',
          callback: action => {
            // 用户点击了确定
            console.log('用户点击了确定');
          }
        });
      });
    },
    sendCode() {
      if (!this.form.email) {
        this.$message.warning(this.t('pleaseInputEmail'));
        return;
      }
      if (!this.form.agree) {
        this.$message.warning(this.t('pleaseAgree'));
        return;
      }

      // Clear any existing countdown
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      this.sendingCode = true;
      const param={
        email:this.form.email
      }

      sendEmailCode(param).then(response => {
        if(response.indexOf('验证码已发送到')>=0){
          // Simulate API call to send verification code
          setTimeout(() => {

            this.sendingCode = false;
            this.$message.success(this.t('codeSent'));

            // Start countdown
            this.isCountingDown = true;
            this.countdown = 60;

            this.countdownInterval = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.countdownInterval);
                this.isCountingDown = false;
              }
            }, 1000);
          }, 1000);
        }
      })

    }
  },
  beforeDestroy() {
    // Clear interval when component is destroyed
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
</script>

<style scoped>
.contact-header-section {
  background-color: #1A2029;
  padding-top: 20px;
  color: white;
}
.contact-header-section {
  background-color: #1A2029;
  padding-top: 20px;
  color: white;
}

.header-content {
  width: 80%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 120px;
  align-items: center;
}

.header-title {
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 15px;
}

.contact-links-row {
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
  width: 40%;
  height: 28px;
  line-height: 3px;
  margin-top: -6px;
  margin-left: 50px;
}

.link-col {
  padding: 13px 0;
  color: #333;
  font-size: 16px;
}

.link-col.middle {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.a-style {
  text-decoration: none;
  color: inherit;
}
.send-code-btn {
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.send-code-btn1 {

  line-height: 0px;

}
.content-wrapper {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background-color: #FFFFFF;

}
.warranty-section {
  display: flex;
  justify-content: space-between;
  padding: 60px 40px;
  max-width: 1000px;
  margin: auto;
  flex-wrap: wrap;

}
.left-box {
  flex: 1;
  min-width: 320px;
  margin-right: 40px;
}
.right-box {
  background-color: #2f2f80;
  border-radius: 10px;
  padding: 30px 20px;
  width: 320px;
  color: white;
  display: flex;
  flex-direction: column;
  height:245px;
  margin-top:65px;
  margin-left:30px;
}
.title {
  font-size: 42px;
  font-weight: bold;
  color: #000;
  height:70px;
  border-bottom: 2px solid #7CAAFB;
  display: inline-block; /* 关键属性 */
}

.description {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #333;
  font-size: 14px;
  margin-left:5px;
}
.description li {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.6;
}
.contact {
  margin-top: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.input {
  margin-bottom: 20px;
  background: white;
}
.code-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.input-code {
  flex: 1;
  margin-right: 10px;
}
.agree {
  margin-bottom: 20px;
  color: #fff;
}

/* Ultra-wide screen adaptations */
@media screen and (min-width: 2560px) {
  .send-code-btn {
    min-width: 160px;
    font-size: 18px;
    height:40px;
    line-height: 5px;
  }
  .send-code-btn1 {
    min-width: 160px;
    font-size: 18px;
    height:40px;
    line-height: 5px;
  }
  .code-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: -5px;
  }
  .warranty-section {
    max-width: 1100px;
    padding: 80px 60px;
  }
  .title {
    font-size: 46px;
    height:70px;
  }
  .description {
    font-size: 18px;
  }
  .description li {
    font-size: 18px;
  }
  .right-box {
    width: 350px;
    padding: 30px 30px;
    height:270px;
    margin-top:65px;
  }
  .contact {
    font-size: 20px;
    margin-top: 30px;
  }
  .input,
  .input-code {
    margin-bottom: 25px;
  }


}

@media screen and (min-width: 3840px) {

  .send-code-btn {
    min-width: 150px;
    font-size: 18px;
    height:40px;
    line-height: 5px;
  }
  .send-code-btn1 {
    min-width: 150px;
    font-size: 18px;
    height:40px;
    line-height: 5px;
  }
  .warranty-section {
    max-width: 1200px;
    padding: 100px 80px;
  }
  .title {
    font-size: 52px;
    margin-bottom: 30px;
    height:70px;
  }
  .description  {
    font-size: 20px;
  }
  .description li {
    font-size: 20px;
    margin-bottom: 18px;
  }
  .contact {
    font-size: 22px;
    margin-top: 30px;
  }
  .right-box {
    width: 350px;
    padding: 50px 40px;
    margin-top:90px;
  }
  .input,
  .input-code {
    margin-bottom: 30px;
  }
  .el-button {
    font-size: 18px;
  }
}

@media screen and (min-width: 5120px) {
  .send-code-btn {
    min-width: 150px;
    font-size: 30px;
    height:40px;
    line-height: 5px;
  }
  .send-code-btn1 {
    min-width: 150px;
    font-size: 30px;
    height:40px;
    line-height: 5px;
  }
  .warranty-section {
    max-width: 1600px;
    padding: 120px 100px;
  }
  .title {
    font-size: 80px;
    margin-bottom: 40px;
    height:120px;
  }
  .description li {
    font-size: 24px;
    margin-bottom: 24px;
  }
  .description {
    font-size: 24px;
    margin-bottom: 24px;
  }
  .contact {
    font-size: 26px;
    margin-top: 40px;
  }
  .right-box {
    width: 350px;
    padding: 30px 40px;
    height:310px;
    margin-top:140px;
    margin-left: 50px;
  }
  .input,
  .input-code {
    margin-bottom: 35px;
  }
  .el-button {
    font-size: 22px;
    padding: 15px 25px;
  }
}

/* Responsive styles */
@media screen and (max-width: 768px) {
  .warranty-section {
    flex-direction: column;
    padding: 30px 20px;
  }
  .right-box {
    width: 100%;
    margin-top: 20px;
  }
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 20px 0;
    width: 90%;
  }

  .header-title {
    font-size: 28px;
    margin-bottom: 20px;
    text-align: center;
  }

  .contact-links-row {
    width: 90%;
    margin: 20px auto 0;
    height: auto;
    line-height: normal;
  }

  .link-col {
    padding: 15px 0;
    font-size: 14px;
  }

  .info-row {
    padding: 20px 10px;
    max-width: 100%;
  }

  .info-col {
    width: 100% !important;
    padding: 0 15px;
  }

  .info-title {
    font-size: 28px;
  }
}

@media screen and (max-width: 480px) {
  .warranty-section {
    flex-direction: column;
    padding: 30px 20px;
  }
  .right-box {
    width: 89%;
    margin-top: 20px;
    margin-left: 0px;
  }
  .header-title {
    font-size: 24px;
  }

  .contact-links-row {
    width: 100%;
  }
  .title{
    font-size:24px;
    height:36px;
  }
  .link-col {
    padding: 12px 0;
    font-size: 12px;
  }
  .description li {
    font-size: 14px;
    margin-bottom: 24px;
  }
  .description {
    font-size: 14px;
  }
  .contact {
    font-size: 15px;
  }
  .info-title {
    font-size: 24px;
  }
}
</style>
